import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import { useEffect } from "react";
import DateRangePicker from "../Reusable/DateRange";

export default function Filter(props: any) {
  const { register, errors, setValue, getValues, clearErrors, watch } = props;
  useEffect(() => {
    const val = getValues("voucher_date__range"); // original string like "2025-09-01,2025-09-23"
    if (typeof val === "string" && val.includes(",")) {
      const [start, end] = val.split(",");
      setValue("voucher_date__range", {
        startDate: new Date(start),
        endDate: new Date(end),
      });
    }
  }, [getValues, setValue]);
  return (
    <div
      className={tw`p-2 rounded-md space-y-2 bg-[#fefefe]`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-3 gap-6`}>
        <MultipleSelectField
          label={"Account"}
          queryKey={"coa"}
          register={register("account__in")}
          watch={watch}
          setValue={setValue}
          url={APIS.COA}
          errors={errors.account__in}
          value={[]}
          props={{
            is_group: false,
            children__isnull: true,
            party__isnull: true,
          }}
        />
        {/* <ComboboxInput
          url={APIS.USER}
          queryKey={"party"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"Party"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search... "}
          clearErrors={clearErrors}
        /> */}
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"voucher_date__range"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}

